"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ImageThumbnailTransform["default"];
  }
});

var _ImageThumbnailTransform = _interopRequireDefault(require("./ImageThumbnailTransform"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }